import React from 'react';
import './Footer.css';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Footer component for the landing page
 * Contains legal links and copyright
 *
 * @param {function} onOpenLegalDocument - Callback to open legal document modal
 */
const Footer = ({ onOpenLegalDocument }) => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        {/* Bottom Links */}
        <nav className="footer-bottom" aria-label={t('a11y.footerNavLabel')}>
          <div className="footer-links">
            {/* Legal Links - Using buttons for modal display */}
            <button
              className="footer-link footer-link-button"
              onClick={() => onOpenLegalDocument('terms')}
              type="button"
            >
              {t('footer.termsAndConditions')}
            </button>
            <button
              className="footer-link footer-link-button"
              onClick={() => onOpenLegalDocument('privacy')}
              type="button"
            >
              {t('footer.privacyPolicy')}
            </button>
            <button
              className="footer-link footer-link-button"
              onClick={() => onOpenLegalDocument('guidelines')}
              type="button"
            >
              {t('footer.communityGuideline')}
            </button>
            <button
              className="footer-link footer-link-button"
              onClick={() => onOpenLegalDocument('impressum')}
              type="button"
            >
              {t('footer.impressum')}
            </button>
          </div>

          {/* Copyright */}
          <p className="footer-copyright">
            ©{currentYear}. {t('footer.copyright')}
          </p>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
